import { ArrowLeft } from "lucide-react";
import { Link, Outlet } from "react-router";

import { LogoLockup } from "@/site/ui/logo";
import { ThemeControl } from "@/theme/theme-control";

// Keep the policies connected to Highlighted without loading account or
// billing controls around public legal documents.
//
export default function LegalLayout() {
  return (
    <div className="highlighted-grid min-h-dvh">
      <header className="bg-background/90 border-b backdrop-blur-xl">
        <div className="mx-auto flex h-17 w-[calc(100%-2rem)] max-w-3xl items-center justify-between sm:w-[calc(100%-3rem)]">
          <LogoLockup linkTo="/" />
          <div className="flex items-center gap-2">
            <Link
              className="text-muted-foreground hover:text-foreground flex items-center gap-1.5 text-sm"
              to="/"
            >
              <ArrowLeft className="size-4" /> Home
            </Link>
            <ThemeControl />
          </div>
        </div>
      </header>
      <main className="mx-auto w-[calc(100%-2rem)] max-w-3xl py-12 sm:w-[calc(100%-3rem)] sm:py-18">
        <Outlet />
      </main>
    </div>
  );
}
